import { KEYCLOAK_ROLES } from '../../shared/constants/auth.constants';
import { CommandAction } from './command-palette.model';

// ────────────────────────────────────────────────────────────────────────────────────────────
// REGISTRO DE AÇÕES DO COMMAND PALETTE (busca universal, ⌘K).
//
// Cada ação é um "verbo" que o usuário pode disparar direto da busca (ex.: "Criar produto"),
// sem navegar pelo menu. Toda rota aqui DEVE existir e ser guardada pelas mesmas roles da rota.
//
// ► AO CRIAR UMA FEATURE NOVA que cadastre/gerencie algo, adicione a ação correspondente aqui.
//   É o que mantém a busca alinhada com as funções do sistema (ver docs/command-palette.md).
// ────────────────────────────────────────────────────────────────────────────────────────────
export const COMMAND_ACTIONS: CommandAction[] = [
  {
    id: 'create-product',
    title: 'Criar produto',
    subtitle: 'Novo cadastro no catálogo',
    icon: 'ti ti-package',
    route: '/produtos/novo',
    roles: [KEYCLOAK_ROLES.PRODUCT],
    keywords: 'novo adicionar cadastrar item catalogo',
  },
  {
    id: 'create-category',
    title: 'Criar categoria',
    subtitle: 'Nova categoria do catálogo',
    icon: 'ti ti-category',
    route: '/categorias/novo',
    roles: [KEYCLOAK_ROLES.CATEGORY],
    keywords: 'nova adicionar cadastrar',
  },
  {
    id: 'create-variation',
    title: 'Criar variação',
    subtitle: 'Novo eixo de variação',
    icon: 'ti ti-adjustments-horizontal',
    route: '/variacoes/novo',
    roles: [KEYCLOAK_ROLES.VARIATION],
    keywords: 'nova adicionar grade cor tamanho',
  },
  {
    id: 'create-advertisement',
    title: 'Criar anúncio',
    subtitle: 'Novo anúncio de marketplace',
    icon: 'ti ti-speakerphone',
    route: '/anuncios/novo',
    roles: [KEYCLOAK_ROLES.ADVERTISEMENT],
    keywords: 'novo publicar listing mercado livre bling',
  },
  {
    id: 'create-integration',
    title: 'Conectar marketplace',
    subtitle: 'Nova integração com um marketplace',
    icon: 'ti ti-plug-connected',
    route: '/integracoes/novo',
    roles: [KEYCLOAK_ROLES.INTEGRATION],
    keywords: 'nova conectar bling mercado livre oauth token autorizar integracao canal',
  },
  {
    id: 'create-webhook-destination',
    title: 'Criar destino de webhook',
    subtitle: 'Novo destino de envio ao ERP',
    icon: 'ti ti-webhook',
    route: '/destinos-webhook/novo',
    roles: [KEYCLOAK_ROLES.WEBHOOK_DESTINATION],
    keywords: 'novo endpoint entrega erp vision integracao saida',
  },
  {
    id: 'create-company',
    title: 'Criar empresa',
    subtitle: 'Nova empresa',
    icon: 'ti ti-building',
    route: '/empresas/novo',
    roles: [KEYCLOAK_ROLES.COMPANY],
    keywords: 'nova adicionar cadastrar loja',
  },
  {
    id: 'create-company-group',
    title: 'Criar grupo de empresas',
    subtitle: 'Novo grupo de empresas',
    icon: 'ti ti-building-community',
    route: '/grupos-empresas/novo',
    roles: [KEYCLOAK_ROLES.COMPANY_GROUP],
    keywords: 'novo adicionar cadastrar',
  },
];
